import React from "react";

import { Layout } from "antd";

const { Content } = Layout;

const UIConatiner = ({ children, style = {}, className = {} }) => {
  return (
    <Content
      className={className}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        margin: "0px 10px",
        background: "#faf9f8",
        minHeight: "80vh",
        ...style,
      }}
    >
      {children}
    </Content>
  );
};

export default UIConatiner;
